export const CHILD_PAGE_NAME = 'CHILD_PAGE_NAME'
